import Vue from 'vue'
import VueI18n from 'vue-i18n'
import IdoniaLocales from '~/locales'

Vue.use(VueI18n)

const messages = {}

IdoniaLocales.locales.forEach(item => {
  messages[item.code] = require(`~/locales/${item.code}.json`)
})

const i18n = new VueI18n({
  locale: IdoniaLocales.defaultLocale.code,
  fallbackLocale: IdoniaLocales.defaultLocale.code,
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js